import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Evenimente from "./pages/Evenimente";
import Contact from "./pages/Contact";
import Opinie from "./pages/Opinie";
import One from "./pages/One";
import Two from "./pages/Two";
import Three from "./pages/Three";
import NoPage from "./pages/NoPage";
import "./custom.css";

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="evenimente" element={<Evenimente />} />
          <Route path="one" element={<One />} />
          <Route path="two" element={<Two />} />
          <Route path="three" element={<Three />} />
          <Route path="contact" element={<Contact />} />
          <Route path="opinie" element={<Opinie />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
